import React from "react";
import { NavLink } from "react-router-dom";

import "./FileLarge.scss";
// import pin from "../../../assets/icons/pin.svg";
import pinned from "../../../assets/icons/pinned.svg";
import folderColor1 from "../../../assets/icons/folder_color-1.svg";
import folderColor2 from "../../../assets/icons/folder_color-2.svg";
import folderColor3 from "../../../assets/icons/folder_color-3.svg";
import folderColor4 from "../../../assets/icons/folder_color-4.svg";
import folderColor5 from "../../../assets/icons/folder_color-5.svg";
import folderColor6 from "../../../assets/icons/folder_color-6.svg";
import folderColorPrimary from "../../../assets/icons/folder_primary.svg";
import SharedIcon from "../../UI/SharedIcon/SharedIcon";

const colors = [
  null,
  folderColor1,
  folderColor2,
  folderColor3,
  folderColor4,
  folderColor5,
  folderColor6,
  folderColorPrimary,
];

const fileLarge = (props) => {
  let pinnedContainer;
  if (props.pinned) {
    pinnedContainer = (
      <div className="pinned" onClick={props.pinHandler}>
        <img alt="PinnedIcon" src={pinned}></img>
      </div>
    );
  }

  return (
    <div className="rectangle-large pl-5 pb-5 mx-3 sm md lg">
      {/* Pin/Pinned Icon */}
      {pinnedContainer}

      {/* Folder Icon */}
      <NavLink
        to={
          props.parentFolderId
            ? `/files/${props.parentFolderId}/${props.folderId}`
            : `/files/${props.folderId}`
        }
      >
        <div className="pt-5">
          <img alt="Icon" src={colors[props.color]}></img>
        </div>
      </NavLink>

      {/* Title */}
      <div className="body-1 bold mt-4 mb-1 d-flex">
        <div className="title-content">{props.title}</div>
        <SharedIcon isFolder={true} itemId={props.folderId} position="right" />
      </div>

      {/* Last opened */}
      <div className="body-1 last-opened">Modified {props.lastOpen}.</div>
    </div>
  );
};

export default fileLarge;
